<template>
  <transition name="page-loader">
    <div v-show="active" class="page-loader">
      <div class="page-loader-content">
        <div class="page-loader-logo">
          <slot name="logo"></slot>
        </div>

        <div class="page-loader-text">
          <slot name="text">
            <p class="h3 text-white mt-5">{{ title }}</p>
            <p class="xxxsmall mt-3">please be patient...</p>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { inject } from 'vue';
const { active, title } = inject('$pageLoader');

</script>

<style lang="scss">
.page-loader {
  z-index: 9999999;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;

  .page-loader-content {
    text-align: center;
  }

  .page-loader-logo {
    max-width: 100%;
    width: 300px;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }

  .page-loader-text {
    color: #fff;
  }
}

///////////////////////////////////////////////////////// Transition
.page-loader-enter-active,
.page-loader-leave-active {
  transition: opacity 250ms ease-out;
}

.page-loader-enter-from,
.page-loader-leave-to {
  opacity: 0;
}
</style>